import { Controller } from "@hotwired/stimulus"
import Lenis from "lenis"

// Drives smooth, momentum-based scrolling for the public marketing site.
// Other controllers can read `window.__lenis` to subscribe to the same scroll loop.
export default class extends Controller {
  connect() {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return

    this.lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      smoothTouch: false
    })
    window.__lenis = this.lenis

    this._raf = (time) => {
      this.lenis.raf(time)
      this._rafId = requestAnimationFrame(this._raf)
    }
    this._rafId = requestAnimationFrame(this._raf)

    document.documentElement.classList.add("lenis-active")
  }

  disconnect() {
    if (this._rafId) cancelAnimationFrame(this._rafId)
    if (this.lenis) {
      this.lenis.destroy()
      this.lenis = null
      window.__lenis = null
    }
    document.documentElement.classList.remove("lenis-active")
  }
}
